import apolloClient from '../../apolloClient';
import eventMutations from '../mutations/event';
import eventQueries from '../queries/event';

const createEvent = async (variables) =>
  apolloClient.mutate({
    mutation: eventMutations.CREATE_EVENT,
    variables,
  });

const getEventById = async (variables) =>
  apolloClient.query({
    query: eventQueries.GET_EVENT_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const updateEventById = async (variables) =>
  apolloClient.mutate({
    mutation: eventMutations.UPDATE_EVENT_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const deleteEventById = async (variables) =>
  apolloClient.mutate({
    mutation: eventMutations.DELETE_EVENT_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const getEventsByIds = async (variables) =>
  apolloClient.query({
    query: eventQueries.GET_EVENTS_BY_IDS,
    fetchPolicy: 'no-cache',
    variables,
  });

export default {
  updateEventById,
  createEvent,
  deleteEventById,
  getEventById,
  getEventsByIds,
};
